const COUNTRY_TO_CURRENCY_CODE_MAP: Record<string, string> = {
  AU: "AUD",
  CA: "CAD",
  DE: "EUR",
  ES: "EUR",
  FR: "EUR",
  GB: "GBP",
  US: "USD",
} as const;

const CURRENCY_CODE_TO_SYMBOL_MAP: Record<string, string> = {
  AUD: "$",
  CAD: "$",
  EUR: "€",
  GBP: "£",
  USD: "$",
} as const;

/** A space's area unit by country */
const COUNTRY_TO_AREA_UNIT_MAP: Record<string, "sqft" | "sqm"> = {
  AU: "sqm",
  CA: "sqft",
  DE: "sqm",
  ES: "sqm",
  FR: "sqm",
  GB: "sqft",
  US: "sqft",
} as const;

export {
  COUNTRY_TO_CURRENCY_CODE_MAP,
  CURRENCY_CODE_TO_SYMBOL_MAP,
  COUNTRY_TO_AREA_UNIT_MAP,
};
